import { render, staticRenderFns } from "./ProjectViewSidebarHistoryCard.vue?vue&type=template&id=378fef66"
import script from "./ProjectViewSidebarHistoryCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarHistoryCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports